import Swap from "@dexhunterio/swaps";
import { Navigation } from "../navigation/navigation";
import Footer from "../footer/footer";
import { useColorMode } from "@chakra-ui/react";

type ColorProps = {
  background: `#${string}`;
  containers: `#${string}`;
  subText: `#${string}`;
  mainText: `#${string}`;
  buttonText: `#${string}`;
  accent: `#${string}`;
};

export const Dex = () => {
  const { colorMode } = useColorMode();

  const getColor = (): ColorProps => {
    if (colorMode === "light") {
      return {
        background: "#edf2f7",
        containers: "#CFD5EE",
        subText: "#3182CE",
        mainText: "#0E0F12",
        buttonText: "#FFFFFF",
        accent: "#3182CE",
      };
    }
    return {
      background: "#000000",
      containers: "#2D2D2D",
      subText: "#A0AEC0",
      mainText: "#E2E8F0",
      buttonText: "#FFFFFF",
      accent: "#3182CE",
    };
  };

  const colors = getColor();

  return (
    <>
      <Navigation />
      <div className="swapComponent">
        <Swap
          orderTypes={["SWAP", "LIMIT"]}
          colors={{
            background: colors.background,
            containers: colors.containers,
            subText: colors.subText,
            mainText: colors.mainText,
            buttonText: colors.buttonText,
            accent: colors.accent,
          }}
          theme={colorMode}
          defaultToken="28193a95061f7f7a64877b6cb8ffea32b30cdb1a73780bfee914032c0014df1052656c61784149"
          width="450"
          style={{ margin: "auto" }}
          partnerCode="relaxai616464723171387276616d6b767565773778356765367a7a776e6773346b357463753665676c666a7837746c3064347a737a397a6872706d7279746c6676756a6461303271356171303063357137677064656a30347779616170356b77376e65713767776d796dda39a3ee5e6b4b0d3255bfef95601890afd80709"
          partnerName="RelaxAI"
          displayType="DEFAULT"
        />
      </div>
      <Footer />
    </>
  );
};
